import { api } from './client.js';

const root = '/admin/settings';

export const settingsApi = {
  list: (params) => api.get(root, { query: params }),
  get: (key) => api.get(`${root}/${encodeURIComponent(key)}`),
  upsert: (key, body) => api.put(`${root}/${encodeURIComponent(key)}`, body),
  remove: (key) => api.delete(`${root}/${encodeURIComponent(key)}`),
  rollback: (key, body) => api.post(`${root}/${encodeURIComponent(key)}/rollback`, body),
  history: (key, params) => api.get(`${root}/${encodeURIComponent(key)}/history`, { query: params })
};
